import { z } from "zod/v4";
import {
	type CreateMembershipType,
	membershipTypeSchema,
	type UpdateMembershipType,
} from "../schemas/membership-type";
import { fetchApi, fetchVoid } from "./internal";

export const membershipTypes = {
	list: (clubId: string) => fetchApi(`/clubs/${clubId}/tiers`, z.array(membershipTypeSchema)),
	create: (clubId: string, data: CreateMembershipType) =>
		fetchApi(`/clubs/${clubId}/tiers`, membershipTypeSchema, {
			method: "POST",
			body: JSON.stringify(data),
		}),
	update: (clubId: string, typeId: string, data: UpdateMembershipType) =>
		fetchApi(`/clubs/${clubId}/tiers/${typeId}`, membershipTypeSchema, {
			method: "PUT",
			body: JSON.stringify(data),
		}),
	delete: (clubId: string, typeId: string) =>
		fetchVoid(`/clubs/${clubId}/tiers/${typeId}`, {
			method: "DELETE",
		}),
};
